<template>
    <PageWrapper>
      <template v-slot:content>
        <el-row :gutter="20">
          <el-col :span="getIsMobile?24:12">
            <el-form :inline="false" ref="formRef"  :label-position="getIsMobile?'top':'right'" :model="form" class="company-info_form" label-width="120px">
              <el-form-item label="客户公司" prop="dscompany">
                <el-input placeholder="请输入客户公司" v-model="form.dscompany" @click.native="dialog = true"/>
              </el-form-item>
              <el-form-item label="部门" prop="dsbumen">
                <el-input placeholder="请输入部门" v-model="form.dsbumen" />
              </el-form-item>
              <el-form-item label="接收人" prop="dsname">
                <el-input placeholder="请输入接收人" v-model="form.dsname" />
              </el-form-item>
              <el-form-item label="电话" prop="dstel">
                <el-input placeholder="请输入电话" v-model="form.dstel" />
              </el-form-item>
              <el-form-item label="传真" prop="dsmax">
                <el-input placeholder="请输入传真" v-model="form.dsmax" />
              </el-form-item>
              <el-form-item label="邮箱" prop="dsemail">
                <el-input placeholder="请输入邮箱" v-model="form.dsemail" />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="getIsMobile?24:12">
            <el-form :inline="false" ref="quoteFormRef" :label-position="getIsMobile?'top':'right'" :model="quoteForm" class="company-info_form"
                     label-width="120px">
              <el-form-item label="报价公司" prop="cname">
                <el-input placeholder="请输入报价公司" v-model="quoteForm.cname" />
              </el-form-item>
              <el-form-item label="部门" prop="bumen">
                <el-input placeholder="请输入部门" v-model="quoteForm.bumen" />
              </el-form-item>
              <el-form-item label="发送人" prop="rname">
                <el-input placeholder="发送人" v-model="quoteForm.rname" />
              </el-form-item>
              <el-form-item label="电话" prop="tel">
                <el-input placeholder="请输入电话" v-model="quoteForm.tel" />
              </el-form-item>
              <el-form-item label="传真" prop="max">
                <el-input placeholder="请输入传真" v-model="quoteForm.max" />
              </el-form-item>
              <el-form-item label="QQ" prop="qq">
                <el-input placeholder="请输入QQ" v-model="quoteForm.qq" />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <Model :data="modelData" ref="modelRef"/>
        <div slot="footer" class="footer">
          <el-button @click="handleReset">重 置</el-button>
          <el-button type="primary" @click="handleSubmit">生成报价单</el-button>
        </div>
        <el-dialog
          v-if="dialog"
          :visible.sync="dialog"
          title="选择报价公司"
          :width="getIsMobile?'100%':'50%'"
          :append-to-body="true"
        >
          <QuotationCompany @selectedCompany="getSelectedCompany"/>
        </el-dialog>
      </template>
    </PageWrapper>
</template>
<script>
import { defineComponent, getCurrentInstance, onMounted, reactive, ref } from '@vue/composition-api'
import PageWrapper from '@/components/PageWrapper/index.vue'
import Model from './model.vue'
import QuotationCompany from '@/views/createQuotation/quotationCompany.vue'
import useRootSetting from '@/hooks/useRootSetting'
import request from '@/utils/request'
import { getToken } from '@/utils/auth'
import { generatePdf } from '@/utils/public-method'
export default defineComponent({
  name: 'CompanyInfo',
  components: { QuotationCompany, PageWrapper, Model },
  setup() {
    const {getIsMobile} = useRootSetting()
    const formRef = ref(null)
    const form = reactive({
      dscompany: '',
      dsbumen: '',
      dsname:'',
      dstel:'',
      dsmax:'',
      dsemail:''
    })

    const quoteForm = reactive({
      cname: '',
      bumen: '销售部',
      rname: '',
      tel: '',
      max: '',
      qq: ''
    })

    const baseInfo = reactive({
      bjdbh:'',
      bjdzy:'',
      bjdtk:'',
      fplx: '',
      bank: '',
      banknum: '',
      wangzhi:'',
      yid:0
    })
    const dialog = ref(false)
    const quoteFormRef = ref(null)
    const modelRef = ref(null)
    const modelData = reactive({})

    const handleReset = () => {
      formRef.value.resetFields()
      modelRef.value.clearTable()
    }
    const handleSubmit = () => {
      request({
        url: 'create_quotation.yy',
        method: 'post',
        data: {
          ...baseInfo,
          ...quoteForm,
          ...form,
          ...{childdata:modelRef.value.modelList}
        }
      }).then(res => {
        if(res.code == 200) {
          const url = `${res.url}&token=${getToken()}`
          generatePdf(url)
        }
      })
    }

    const getSelectedCompany = (row) => {
       const {company,bumen,name,phone,max,email} = row
        form.dscompany = company
        form.dsbumen = bumen
        form.dsname = name
        form.dstel = phone
        form.dsmax = max
        form.dsemail = email
        dialog.value = false
    }

    const instance = getCurrentInstance()
    const username = instance.proxy.$store.getters.name
    const getQuotation = () => {
      request({
        url: 'quotation_information.yy',
        method: 'post',
        data: {username:username}
      }).then(res => {
         if(res.code == 200) {
           Object.assign(quoteForm, res.supplierrow[0]);
           Object.assign(baseInfo,res.supplierrow[0])
         }
      })
    }

    onMounted(() => {
      getQuotation()
    })
    return {
      baseInfo,
      username,
      getIsMobile,
      modelRef,
      dialog,
      quoteForm,
      quoteFormRef,
      formRef,
      form,
      modelData,
      getSelectedCompany,
      handleReset,
      handleSubmit
    }
  }
})
</script>

<style scoped>
.company-info_form {
  padding: 40px 60px 40px 20px
}

.footer {
  float: right;
  margin-top: -30px;
  margin-right: 30px;
}
</style>
